export const defaultState = () => ({
  savedViews: []
});

const state = defaultState();

export default state;
